import { render, staticRenderFns } from "./momentoAllInOneProductFocus.vue?vue&type=template&id=1cb9e18f&"
import script from "./momentoAllInOneProductFocus.vue?vue&type=script&lang=js&"
export * from "./momentoAllInOneProductFocus.vue?vue&type=script&lang=js&"
import style0 from "./momentoAllInOneProductFocus.vue?vue&type=style&index=0&id=1cb9e18f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports